import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { authAPI } from '../services/api'

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('admin@example.com')
  const [resetToken, setResetToken] = useState('')
  const [newPassword, setNewPassword] = useState('')
  const [message, setMessage] = useState('')
  const [error, setError] = useState('')

  const requestReset = async () => {
    setError(''); setMessage('')
    try {
      const response = await authAPI.requestPasswordReset(email)
      const data = response.data
      setResetToken(data.data?.resetToken || '')
      setMessage('Reset token generated (internal). Use it below to set a new password.')
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message || 'Failed'
      setError(errorMessage)
    }
  }

  const submitReset = async () => {
    setError(''); setMessage('')
    try {
      await authAPI.resetPassword(resetToken, newPassword)
      setMessage('Password updated. You can login now.')
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message || 'Failed'
      setError(errorMessage)
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 p-6">
      <div className="w-full max-w-md bg-white rounded-lg shadow p-6 space-y-4">
        <h1 className="text-xl font-semibold">Forgot Password</h1>
        {error && <div className="text-red-600 text-sm">{error}</div>}
        {message && <div className="text-green-600 text-sm">{message}</div>}
        <div>
          <label className="block text-sm text-gray-600 mb-1">Email</label>
          <input className="w-full border rounded px-3 py-2" value={email} onChange={(e)=>setEmail(e.target.value)} />
          <button className="mt-2 w-full bg-blue-600 text-white rounded px-3 py-2" onClick={requestReset}>Request reset</button>
        </div>
        <div>
          <label className="block text-sm text-gray-600 mb-1">Reset Token</label>
          <textarea rows={3} className="w-full border rounded px-3 py-2" value={resetToken} onChange={(e)=>setResetToken(e.target.value)} />
        </div>
        <div>
          <label className="block text-sm text-gray-600 mb-1">New Password</label>
          <input type="password" className="w-full border rounded px-3 py-2" value={newPassword} onChange={(e)=>setNewPassword(e.target.value)} />
          <button className="mt-2 w-full bg-green-600 text-white rounded px-3 py-2" onClick={submitReset}>Reset Password</button>
        </div>
        <div className="text-right text-sm">
          <Link to="/login" className="text-blue-600 hover:underline">Back to login</Link>
        </div>
      </div>
    </div>
  )
}

export default ForgotPasswordPage


